<script>
import Mixin from "@utilities/mixin";

export default {
  name: "SettingsMain",
  mixins: [Mixin],
  data: () => ({
    newStoreName: "",
  }),
  computed: {
    shops() {
      return this.$store.state.shops;
    }
  },
  methods: {
    addNewStore() {
      if (this.newStoreName) {
        this.addStore(this.newStoreName);
        this.newStoreName = "";
      }
    },
  },
  created() {
    this.getShops();
  }
}
</script>

<template>
<div class="container mt-3">
  <h2 class="my-3">Settings</h2>
  <Panel header="Store Management">
    <div class="d-flex gap-2 align-items-center mb-3">
      <InputText id="new-store" v-model="newStoreName" aria-label="Add New Store" placeholder="Add New Store"></InputText>
      <Button label="Save" icon="pi pi-check" @click="addNewStore"/>
    </div>
    <div>
      <Card class="mb-2" v-for="store in shops">
        <template #title>{{ store.name }}</template>
      </Card>
    </div>
  </Panel>
</div>

</template>
